import React from 'react';
import { X } from 'lucide-react';
import {
  opNecesitaDosValores, opNecesitaValor, VALIDACIONES, validacionesDe,
} from '../../../lib/formularios';
import { useEditor } from './contexto';
import { Selector } from './controles';

/** Validación por defecto al activarla desde el menú de la pregunta. */
export function validacionInicial(tipo) {
  if (tipo === 'casillas') return { tipo: 'seleccion', op: 'al_menos', valor: 1, valor2: null, mensaje: '' };
  if (tipo === 'parrafo') return { tipo: 'longitud', op: 'max', valor: 500, valor2: null, mensaje: '' };
  return { tipo: 'numero', op: 'mayor', valor: '', valor2: null, mensaje: '' };
}

function patronRoto(patron) {
  try {
    // eslint-disable-next-line no-new
    new RegExp(patron || '');
    return false;
  } catch {
    return true;
  }
}

/**
 * Fila de "Validación de respuestas" bajo la pregunta: tipo, condición, valor(es) y el texto de error
 * propio. Lo que se escribe aquí lo vuelve a comprobar el servidor al recibir cada respuesta.
 */
export default function EditorValidacion({ item }) {
  const { cambiarItem } = useEditor();
  const v = item.validacion;
  if (!v) return null;

  const tipos = validacionesDe(item.tipo);
  const catalogo = VALIDACIONES[v.tipo] || VALIDACIONES[tipos[0]];
  const set = (campos, clave) => cambiarItem(item.id, { validacion: { ...v, ...campos } }, { clave: clave ? `${item.id}:validacion:${clave}` : undefined });

  const cambiarTipo = (tipo) => {
    const primera = Object.keys(VALIDACIONES[tipo].ops)[0];
    set({ tipo, op: primera, valor: tipo === 'longitud' || tipo === 'seleccion' ? 1 : '', valor2: null });
  };

  const numerico = v.tipo === 'numero' || v.tipo === 'longitud' || v.tipo === 'seleccion';
  const invalido = v.tipo === 'regex' && patronRoto(v.valor);

  return (
    <div className="fe-validacion" role="group" aria-label="Validación de respuestas">
      <div className="fe-validacion-fila">
        {tipos.length > 1 && (
          <Selector
            value={v.tipo}
            onChange={cambiarTipo}
            opciones={tipos.map((t) => ({ valor: t, texto: VALIDACIONES[t].nombre }))}
            etiqueta="Tipo de validación"
          />
        )}
        <Selector
          value={v.op}
          onChange={(op) => set({ op })}
          opciones={Object.entries(catalogo.ops).map(([valor, texto]) => ({ valor, texto }))}
          etiqueta="Condición"
        />
        {opNecesitaValor(v.op) && (
          <input
            className="fm-campo-linea fe-validacion-valor"
            type={numerico ? 'number' : 'text'}
            inputMode={numerico ? 'decimal' : undefined}
            value={v.valor ?? ''}
            placeholder={v.tipo === 'regex' ? 'Patrón' : v.tipo === 'texto' ? 'Texto' : 'Número'}
            aria-label="Valor"
            onChange={(e) => set({ valor: numerico && e.target.value !== '' ? Number(e.target.value) : e.target.value }, 'valor')}
          />
        )}
        {opNecesitaDosValores(v.op) && (
          <>
            <span className="fe-texto-2">y</span>
            <input
              className="fm-campo-linea fe-validacion-valor"
              type="number"
              inputMode="decimal"
              value={v.valor2 ?? ''}
              placeholder="Número"
              aria-label="Segundo valor"
              onChange={(e) => set({ valor2: e.target.value === '' ? null : Number(e.target.value) }, 'valor2')}
            />
          </>
        )}
        <input
          className="fm-campo-linea fe-validacion-mensaje"
          value={v.mensaje || ''}
          placeholder="Texto de error personalizado"
          aria-label="Texto de error personalizado"
          onChange={(e) => set({ mensaje: e.target.value }, 'mensaje')}
        />
        <button type="button" className="fe-icono-btn" onClick={() => cambiarItem(item.id, { validacion: null })} aria-label="Quitar validación" title="Quitar validación">
          <X />
        </button>
      </div>
      {invalido && <div className="fe-aviso-campo">La expresión regular no es válida: no se aplicará hasta corregirla.</div>}
    </div>
  );
}
